import React, { Component } from 'react';
import StripeCheckout from 'react-stripe-checkout';

import { Table, TableBody, TableRow, TableRowColumn } from 'material-ui/Table';
import { Card, CardText } from 'material-ui/Card';
import RaisedButton from 'material-ui/RaisedButton';
import CircularProgress from 'material-ui/CircularProgress';
import moment from 'moment';
import Config from '../conf';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';

const Theme = Config.THEME;

import 'whatwg-fetch';

class Confirm extends Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      error: false,
      paymentComplete: false
    };

    this.retry = this.retry.bind(this);
    this.refreshPage = this.refreshPage.bind(this);
    this.onPayPalConfirm = this.onPayPalConfirm.bind(this);
  }

  componentDidMount() {
    this.onPayPalConfirm();
  }

  onPayPalConfirm() {
    // set loading status
    this.setState({
      loading: true
    });

    const body = {
      paypal: this.props.details.paypal
    };
    fetch(Config.BACKEND_API_URL + 'carpark/paypal/confirm', {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    }).then((response) => {
      return response.json();
    }).then((data) => {
      console.log('response was: ' + JSON.stringify(data, null, 2));
      if (data.status === 200 ) {
        this.setState({
          paymentComplete: true
        });
      } else {
        throw Error('response status from backend was ' + data.status + ' (data = ' + JSON.stringify(data) + ')');
      }
    }).catch((err) => {
      // set error
      this.setState({
        error: true
      });
      console.log('err:', err);
    });    
  }

  refreshPage() {
    location.reload();
  }

  retry() {
    this.onPayPalConfirm();
  }

  render() {
    const styles = {
      card: {
        padding: 30,
        paddingTop: 40,
        textAlign: 'center',
        borderRadius: 12
      },
      title: {
        textAlign: 'center',
        margin: 0,
        color: Theme.palette.primary1Color,
        marginBottom: 20
      },
      button: {
        width: 100,
        marginTop: 20,
        marginLeft: 5,
        marginRight: 5
      },
    };

    const rows = [
      { name: 'Full Name', value: this.props.details.name },
      { name: 'Email Address', value: this.props.details.email },
      { name: 'Mobile Number', value: this.props.details.phone },
      { name: 'Number Plate', value: this.props.details.numberPlate },
      { name: 'Wash Details', value: this.props.details.washDescription },
      { name: 'Wash Date', value: moment(this.props.details.created).format('YYYY/MM/DD') }
    ];

    return (
      <div>
        {this.state.loading && !this.state.paymentComplete && !this.state.error &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Processing your payment...</h2>
            <CardText>
              <CircularProgress />
            </CardText>
          </Card>
        }
        {this.state.paymentComplete &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Done!</h2>
            <CardText>
              <p>Your payment has been received. We hope you've enjoyed our service!</p>
              <p>
                When you require another carwash in the future, simply spend 2 minutes to make a booking on our main
              website at <a href="https://www.wipehero.com.au/">www.wipehero.com.au</a> and <strong>we'll come to
              you!</strong>
              </p>
            </CardText>
          </Card>
        }
        {this.state.error && !this.state.paymentComplete &&
          <Card style={styles.card}>
            <h2 style={styles.title}>Error</h2>
            <CardText>
              <div>
                Your payment has been declined, please try again. If this issue persists, please contact us on
                1300 791 421 or email hello@wipehero.com
            </div>
              <div>
                <RaisedButton
                  style={{ ...styles.button, ...{ marginTop: 40 } }}
                  label="Retry"
                  primary={true}
                  onClick={this.retry}
                />
              </div>
            </CardText>
          </Card>
        }
      </div>
    );
  }
}

export default Confirm;



// WEBPACK FOOTER //
// ./src/app/payment/PayPal.js